import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    personFirstName?: ?string;
}

export class TimesheetEntryPersonFirstName extends React.PureComponent<Props> {
    render() {
        const { personFirstName } = this.props;
        if (!personFirstName) return null;
        return personFirstName;
    }
}

const mapStateToProps = createStructuredSelector({
    personFirstName: makeSelectTimesheetEntryValue('personFirstName')
});

export default connect(mapStateToProps)(TimesheetEntryPersonFirstName);
